import { Stack } from '@mantine/core';

import type { ResponseProjectBlock } from '../../../../../../../../../shared/entities/ResponseProjectBlock';
import { BlockAssistant } from './BlockAssistant';
import { BlockContent } from './BlockContent';
import { BlockWrapper } from './BlockWrapper';

interface BlockProps {
  block: ResponseProjectBlock;
}

export function Block({ block }: BlockProps) {
  const children = block.getChildren();

  const showChildren = children.length > 0 || !!block.content;

  return (
    <BlockWrapper
      block={block}
      assistantTrigger={<BlockAssistant block={block} />}
    >
      {showChildren && (
        <Stack spacing="02" w="100%">
          <BlockContent block={block} />
          {children.map(child => (
            <Block key={child.id} block={child} />
          ))}
        </Stack>
      )}
    </BlockWrapper>
  );
}
